import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aq-oneeight-onenine',
  templateUrl: './aq-oneeight-onenine.component.html',
  styleUrls: ['./aq-oneeight-onenine.component.scss']
})
export class AqOneeightOnenineComponent implements OnInit {
  src: string ='/assets/pdf/NAAC_2018-19.pdf';
  constructor() { }

  ngOnInit(): void {
  }

}
